const { ALGOLIA_APPLICATION_ID, ALGOLIA_ENV, ALGOLIA_SEARCH_API, APP_ENV } = process.env

export const applicationId: string = ALGOLIA_APPLICATION_ID || ''
export const searchApi: string = ALGOLIA_SEARCH_API || ''
const algoliaEnv: string = ALGOLIA_ENV || APP_ENV || 'production'
export const searchIndice: string = `${algoliaEnv}_artwork_in_collections`

// Will add additional sort options in part 2.
export const sortOptions: Array<{
  value: string
  title: string
  indice: string
}> = [
  {
    value: 'default',
    title: 'Default',
    indice: searchIndice,
  },
]

export const ARTWORK_STATUS = {
  AVAILABLE: 'avail',
  RESERVED: 'reserved',
  SOLD: 'sold',
  UNAVAILABLE: 'unavail',
}

export const FALLBACK_DATA = {
  title: 'Curated Deals',
  subTitle: 'Check Back Soon For Our Next Drop.',
  description: `20 curator-approved original artworks from our bestselling artists, offered at reduced, limited-time prices.`,
}

export const TILES_DATA = [
  {
    url: '/all',
    name: 'One-Of-A-Kind-Art',
    imageUrl: '//d3t95n9c6zzriw.cloudfront.net/common/one-of-a-kind-art.jpg',
    linkTitle: 'Explore Art',
  },
  {
    url: '/prints',
    name: 'Fine Art Prints',
    imageUrl: '//d3t95n9c6zzriw.cloudfront.net/common/fine-art-print.jpg',
    linkTitle: 'Explore Art Prints',
  },
  {
    url: '/quiz/art-for-your-style-quiz ',
    name: 'Find Out Your Art Style',
    imageUrl: '//d3t95n9c6zzriw.cloudfront.net/common/art-style-quiz.jpg',
    linkTitle: 'Take Our Quiz',
  },
  {
    url: '/artadvisory',
    name: 'Complimentary Art Advisory',
    imageUrl: '//d3t95n9c6zzriw.cloudfront.net/common/art-advisory.jpg',
    linkTitle: 'Get Started',
  },
]
